import { Component, Input, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { Subscription } from 'rxjs';
import { ActivatedRoute, Data } from '@angular/router';
import { FormControl, FormGroup } from '@angular/forms';
import { UserMessage } from 'src/app/client/repositories/user-message/models/user-message.model';
import { UserMessageRepository } from 'src/app/client/repositories/user-message/user-message.repository';
import { UserMessageSearchQuery } from 'src/app/client/repositories/user-message/models/user-message-search-query.model';
import { SenderDetails } from 'src/app/client/repositories/user-message/models/sender-details.model';
import { UserRepository } from 'src/app/client/repositories/user/user.repository';
import { CustomerPortalUser } from 'src/app/client/repositories/user/models/user.model';
import { UserMessageChatInputModalComponent } from '../user-message-chat-input-modal/user-message-chat-input-modal.component';
import { ScreenBreakpointObserverService } from 'src/app/shared/foundation/utils/breakpoint-observer.service';

@Component({
  selector: 'app-user-message-thread',
  templateUrl: './user-message-thread.component.html',
  styleUrls: ['./user-message-thread.component.scss'],
})
export class UserMessageThreadComponent implements OnInit, OnDestroy {
  prefix = 'userMessages.';
  @ViewChild('chatInputModel')
  chatInputModel: UserMessageChatInputModalComponent;

  private $userMessage: UserMessage;

  private subscriptions: Array<Subscription> | undefined = [];

  messages: Array<UserMessage> = [];

  rootObjectId: string;
  rootObjectType: string = 'CLAIM';

  user: CustomerPortalUser;

  isMobileLayout = false;

  constructor(
    private $route: ActivatedRoute,
    private userMessageRepository: UserMessageRepository,
    private userRepository: UserRepository,
    private bpObserverService: ScreenBreakpointObserverService,
    private route: ActivatedRoute
  ) {
    this.route.queryParams.subscribe((params) => {
      // this.rootObjectId = params['claimNumber'];
      this.loadMessages(params['claimNumber']);
    });
  }

  ngOnInit(): void {
    this.bpObserverService.screenSizeObserver.subscribe({
      next: (res) => {
        if (res.length <= 2) {
          this.isMobileLayout = true;
        } else {
          this.isMobileLayout = false;
        }
      },
    });

    this.subscriptions?.push(
      this.$route.parent!.data.subscribe((data: Data) => {
        this.$userMessage = data['userMessage'];
      })
    );

    this.getUser();
    // this.loadMessages();
  }

  getUser() {
    this.userRepository.getUser().subscribe({
      next: (res) => {
        this.user = res;
      },
      error: (err) => {
        console.log(err);
      },
    });
  }

  ngOnDestroy(): void {
    if (this.subscriptions && this.subscriptions.length > 0) {
      this.subscriptions.forEach((s) => s.unsubscribe());
      this.subscriptions = undefined;
    }
  }

  get userMessage(): UserMessage {
    return this.$userMessage;
  }

  get resolverRoute(): ActivatedRoute {
    return this.$route.parent as any;
  }

  loadMessages(rootObjectId: string): void {
    this.rootObjectId = rootObjectId;
    this.userMessageRepository
      .getMessageThread({
        rootObjectId: rootObjectId,
        rootObjectType: this.rootObjectType,
      } as UserMessageSearchQuery)
      .subscribe({
        next: (res: any) => {
          this.messages = res;
        },
        error: (err) => {
          console.log(err);
        },
      });
  }

  submit(message: string): void {
    this.userMessageRepository
      .sendMessage({
        content: message,
        rootObjectId: this.rootObjectId,
        rootObjectType: this.rootObjectType,
      } as UserMessage)
      .subscribe({
        next: (res) => {
          this.loadMessages(this.rootObjectId);
        },
        error: (err) => {
          console.log(err);
        },
      });

    this.chatInputModel.formGroup.controls.message.reset();
    this.chatInputModel.modalRef.close();
  }
}
